import isSeries from "./isSeries";
import { isAccessLimitedByParentalLevel } from "../services/parentalControlService";
import { routes, sections } from "../routes";
import { redirectTo } from "../services/navigationService";

/**
 * Checks if layout section received is "arabic" or "kids". Thie will be checked after coming either from
 * a layout section, search page or layout section from which a full catalog comes from.
 * @param {String} sectionName - Section name coming from Layout section, Search or FullCatalog's layout section.
 */
function checkSectionNameForDetailPage(sectionName) {
  return [sections.ARABIC, sections.KIDS].indexOf(sectionName) > -1 ? `/${sectionName}` : "";
}

/**
 * Redirects to a certain detail page, given by its ID, but taking its programType into account.
 * @param {String} id - Title ID to which be redirected to.
 * @param {String} programType - Program type, either "series" or "movies".
 * @param {String} moduleId - Module ID coming from the layouts to be used on user events.
 * @param {String} sectionName - Section from which to be redirected.
 */
export function goToDetailPageByProgramType({ id, programType, moduleId, sectionName, from = null }) {
  const section = isAccessLimitedByParentalLevel() ? `/${sections.KIDS}` : checkSectionNameForDetailPage(sectionName);
  const goToPath =
    programType === sections.SERIES ? `${section}${routes.series}/${id}` : `${section}${routes.movies}/${id}`;
  redirectTo.call(this, goToPath, { moduleId, sectionAnalytics: sectionName, from });
}

// FIXME This will be the same in all the apps, maybe it should be in the SDK
/**
 * Redirects to a certain title detail page, given its ID.
 * @param {String} id - Title ID to which be redirected to.
 * @param {Object} tagList - Object containing title genres and categories related data.
 * @param {String} moduleId - Module ID coming from the layouts to be used on user events.
 * @param {String} sectionName - Section from which to be redirected.
 * @param {String} sectionAnalytics - Section related data from which to be redirected. Used for analytics purposes.
 */
export function goToDetailPage({ id, tagList, moduleId, sectionName, sectionAnalytics = sectionName, from = null, isNotMovie }) {
  // TODO Discuss if the app should really do this. What happens is that the URL gets a path for the section tag found in the title, for example /kids/ for content tagged as for kids.
  // This happens even if the content was selected from the homepage. Defining this will define how we solve different issues like:
  // - https://starzplay.atlassian.net/browse/WBIGS-603
  // - https://starzplay.atlassian.net/browse/WBIGS-870
  // - Implementation of withSubTheme HOC
  const section = isAccessLimitedByParentalLevel() ? `/${sections.KIDS}` : checkSectionNameForDetailPage(sectionName);
  const goToPath = isNotMovie===true || isSeries(tagList["categories"])
    ? `${section}${routes.series}/${id}`
    : `${section}${routes.movies}/${id}`;
  redirectTo.call(this, goToPath, { moduleId, sectionAnalytics, from });
}
